module.exports = __webpack_public_path__ + "static/media/boitesTupp_01_thumb.af5d146b.png";